<template>
    <gcmcn-layout
        title="MISMATCH"
        custom-class="mismatch-view"
    >
        <ns-paginate
            ref="nsPaginate"
            baseUrl="booking-mismatch/"
            tableTitle="Booking mismatch"
            :hide-filters-by-default="true"
            :customFiltersToApply="filtersToApply"
            dark
        >
            <div
                slot="list"
                slot-scope="props"
            >
                <el-table
                    :data="props.list"
                    style="width: 100%"
                    class="ns-paginate-table dark-theme"
                >
                    <el-table-column
                        prop="feed_name"
                        label="Feed"
                    ></el-table-column>
                    <el-table-column
                        prop="event_name"
                        label="Event"
                    ></el-table-column>
                    <el-table-column
                        prop="entity_name"
                        label="Entity"
                    ></el-table-column>
                    <el-table-column
                        prop="start_date"
                        label="Start date (UTC)"
                    >
                        <template slot-scope="scope">
                            {{ dateUtc(scope.row.start_date) }}
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="end_date"
                        label="End date (UTC)"
                    >
                        <template slot-scope="scope">
                            {{ dateUtc(scope.row.end_date) }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="errors" label="Error"></el-table-column>
                    <el-table-column
                        label="Action"
                        width="150"
                    >
                        <template slot-scope="scope">
                            <el-button type="primary" @click="toggleResolveModal(scope.row)">Resolve</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </ns-paginate>
        <resolve-modal ref="resolveModal"></resolve-modal>
    </gcmcn-layout>
</template>

<script>
import moment from 'moment';
import GcmcnLayout from '../../partials/gcmcn-layout.vue';
import NsPaginate from 'fundation-app-vuejs/src/components/partials/nsPaginate2';
import resolveModal from './resolveModal.vue';
import {mapGetters} from 'vuex';
export default {

    components: {
        GcmcnLayout,
        NsPaginate,
        resolveModal
    },

    props: {

    },

    data: function(){
        return {

        };
    },

    computed: {
        ...mapGetters([
            'userIsAtLeastAdmin',
            'entitiesByUid',
            'userIsEntityAdmin'
        ]),
    },

    mounted: function(){

    },

    methods: {
        toggleResolveModal(mismatch) {
            this.$refs.resolveModal.open(mismatch);
        },
        filtersToApply() {
            return {
                resolved: false,
                archived: false,
            };
        },
        dateUtc (date){
            return moment.utc(date).format('YYYY-MM-DD HH:mm:ss');
        },
    },
};
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/page/Mismatches/index.vue